<template>
    <div class="setting-body">
        <el-tabs v-model="selectedTabName" type="card">
            <el-tab-pane :label="settingTitle" name="setting">
                <el-form label-width="250px" style="padding-top:20px">
                    <el-form-item ref="displayName">
                        <div class="input-form-setting" slot="label" v-t="'message.title_ai_display_name'"></div>
                        <el-input
                            id="displayName"
                            :placeholder="$t('message.place_holder_input_text')"
                            v-model="form.displayName"
                            @compositionstart.native="compositionStart"
                            @compositionend.native="compositionEnd"
                            @input.native="checkDisplayName"
                            clearable
                            @clear="checkDisplayName"/>
                    </el-form-item>
                    <DefinitionParameterEditForm
                        v-for="section in visibleSections"
                        :key="section.name.en"
                        :isNew="isNew"
                        v-model="section"
                        @update:valid="updateValid(section, $event)"
                        @showLoadingScreen="showLoadingScreen"
                        @closeLoadingScreen="closeLoadingScreen"
                    />
                </el-form>
            </el-tab-pane>
            <el-tab-pane v-if="helpHtmlUrl" style="margin:0" :label="$t('message.info_how_to_set')" name="help">
                <iframe width="1000" height="420" style="border: 0" :src="helpHtmlUrl"></iframe>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import AiAppSettingUtility from "@/components/pc/setting/ai-app/AiAppSettingUtility";
import processorTemplateUtil from "@/components/pc/setting/ai-app/AiAppSettingUtil";
import DefinitionParameterEditForm from "@/components/pc/setting/ai-app/DefinitionParameterEditForm";

export default {
    name: "AiAppSettingDefinitionForm",

    mixins:[AiAppSettingUtility],

    components:{ DefinitionParameterEditForm },

    model: {
        prop: 'form',
    },

    props: {
        form: {
            type: Object,
            required: true
        },
        settingTitle: {
            type: String,
            required: true
        },
        helpHtmlUrl: {
            type: String,
            default: null
        },
        isNew: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            displayNameValidator: null,
            valid: false,
            validMap: new Map(),
            selectedTabName: "setting",
            loadingScreen: false,
        }
    },

    computed: {
        visibleSections() {
            let visibleSections = this.form.sections.filter(section => processorTemplateUtil.shownContentsExist(section));

            this.validMap.clear()
            for (let section of visibleSections) {
                this.validMap.set(section.name.en, false)
            }

            return visibleSections
        }
    },

    created() {
        this.displayNameValidator = processorTemplateUtil.getDisplayNameValidator()
        processorTemplateUtil.validateItem(this.$i18n, this.displayNameValidator, this.form.displayName)

        for (let section of this.visibleSections) {
            this.validMap.set(section.name.en, false)
        }
    },

    methods: {
        updateValid(section, valid) {
            this.validMap.set(section.name.en, valid)

            let oldValidStatus = this.valid
            let newValidStatus = true;
            for (let value of this.validMap.values()) {
                newValidStatus = newValidStatus && value
            }

            this.valid = newValidStatus
            if ((oldValidStatus && this.displayNameValidator.valid) !== (newValidStatus && this.displayNameValidator.valid)) {
                this.$emit('update:valid', this.valid & this.displayNameValidator.valid);
            }
        },
        checkDisplayName() {
            let oldValidValue = this.displayNameValidator.valid
            let validateSkipped = processorTemplateUtil.validateItem(this.$i18n, this.displayNameValidator, this.form.displayName);
            if (validateSkipped) {
                // inputting with IME
                return;
            }
            processorTemplateUtil.overwriteValidationResultToRef(this.$refs.displayName, this.displayNameValidator);

            if ((this.valid && oldValidValue) !== (this.valid && this.displayNameValidator.valid)) {
                this.$emit('update:valid', (this.valid && this.displayNameValidator.valid));
            }
        },

        showLoadingScreen() {
            if (this.loadingScreen != null) {
                return;
            }
            // save after permission check if passed
            this.loadingScreen = this.$loading({
                lock: true ,
                text: 'Loading data ...' ,
                spinner: 'el-icon-loading' ,
                background: 'rgba(0, 0, 0, 0)'
            });
        },

        closeLoadingScreen() {
            if (this.loadingScreen != null) {
                this.loadingScreen.close();
                this.loadingScreen = null;
            }
        },

        compositionStart() {
            this.displayNameValidator.isComposing = true;
        },

        compositionEnd() {
            this.displayNameValidator.isComposing = false;
            this.checkDisplayName()
        },
    }
}
</script>

<style scoped>
:deep() .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
    background-color: #fff;
    color: #606266;
}

:deep() .el-tabs__header {
    padding: 0;
    position: relative;
    margin: 0;
    background-color: #f6f6f6;
    color: #848991;
}

.setting-body {
    padding:0;
    font-size: 14px;
}

.input-form-setting {
    padding-left: 15px;
    text-align: left;
}

.el-form-item {
    margin-right: 100px
}

</style>
